import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchClientByClientIdRequest,
  selectClientIsLoading,
  selectMaybeClient,
  selectSession,
} from '@client';
import { useClerkClientAuth } from '@client/hooks/useClerkClientAuth';

export const useClientData = () => {
  const { isClerkSignedIn, isClerkLoading } = useClerkClientAuth();
  const { clientId } = useParams();
  const dispatch = useDispatch();
  const client = useSelector(selectMaybeClient);
  const clientIsLoading = useSelector(selectClientIsLoading);
  const { advisor } = useSelector(selectSession);

  const isUserAuthenticated = isClerkSignedIn;
  const isLoading = isClerkLoading || clientIsLoading;

  const shouldBeLoadingClientData =
    !client || (!clientIsLoading && isUserAuthenticated && !advisor);

  useEffect(() => {
    if (
      clientId &&
      (!client || client.clientId !== clientId) &&
      !isLoading &&
      isUserAuthenticated
    ) {
      dispatch(fetchClientByClientIdRequest(clientId));
    }
  }, [clientId, client, dispatch, isLoading, isUserAuthenticated]);

  return {
    client,
    isLoading,
    shouldBeLoadingClientData,
    authLoading: isClerkLoading,
    clientIsLoading,
  };
};
